module.exports = __webpack_public_path__ + "public/img/avatar.4d60da83.png";